import React, { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getSignInUrl } from 'utils'
import { WALK_UP_REG_FULL_URL } from 'constants/global'
import styles from './lockedFeature.module.scss'

interface Props {
  children: ReactNode
  info: { ns: string; transKey: string }
}

const LockedFeature = ({ children, info }: Props) => {
  const { t } = useTranslation(info.ns)

  return (
    <div className={styles.blurredContainer}>
      <div className={styles.content}>
        <p className={styles.info}>{t(info.transKey)}</p>
        <Trans ns='strMessageScreen' i18nKey={'lockedFeature.logInOrSignUp'}>
          <p>
            <a href={getSignInUrl()}>Log in</a> or <a href={WALK_UP_REG_FULL_URL}>Sign up</a> for an
            account.
          </p>
        </Trans>
      </div>

      <div className={styles.blurred} aria-hidden>
        {children}
      </div>
    </div>
  )
}

export default LockedFeature
